import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import { Button } from "./Button";

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const closeMobileMenu = () => setClick(false);
  const handleClick = () => setClick(!click);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  window.addEventListener("resize", showButton);

  return (
    <nav className="fm-navbar">
      <div className="fm-navbar__container">
        <Link to="/" className="fm-navbar__brand">
          <img
            src="/images/fenixlogofinalversion.png"
            alt="Fenix Media"
            className="fm-navbar__logo"
          />
        </Link>

        <div className="fm-navbar__menu-icon" onClick={handleClick}>
          <i className={click ? "fas fa-times" : "fas fa-bars"} />
        </div>

        <ul className={click ? "fm-navbar__menu active" : "fm-navbar__menu"}>
          <li>
            <Link to="/portfolio" className="fm-navbar__link" onClick={closeMobileMenu}>
              PORTFOLIO
            </Link>
          </li>
          <li>
            <Link to="/about" className="fm-navbar__link" onClick={closeMobileMenu}>
              ABOUT
            </Link>
          </li>
          <li>
            <Link to="/services" className="fm-navbar__link" onClick={closeMobileMenu}>
              SERVICES
            </Link>
          </li>
          <li>
            <Link to="/contact" className="fm-navbar__link" onClick={closeMobileMenu}>
              CONTACT
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;

